import React from 'react';
import {
  Box,
  InputGroup,
  Input,
  InputRightElement,
  Button,
  Icon,
  useColorModeValue
} from '@chakra-ui/react';
import { FiSend } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

interface ChatInputProps {
  value: string;
  onChange: (value: string) => void;
  onSend: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
}

const ChatInput: React.FC<ChatInputProps> = ({
  value,
  onChange,
  onSend,
  isDisabled = false,
  isLoading = false
}) => {
  const { t } = useTranslation();
  const accentColor = useColorModeValue('blue.500', 'blue.400');

  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !isDisabled) {
      onSend();
    }
  };

  return (
    <Box w="full" p={6} bg={useColorModeValue('white', 'gray.800')} borderBottomRadius="3xl">
      <InputGroup size="lg">
        <Input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={t('onboarding.vocabulary.chatPlaceholder')}
          borderRadius="xl"
          border="2px"
          borderColor={useColorModeValue('gray.200', 'gray.600')}
          _focus={{ borderColor: accentColor, boxShadow: `0 0 0 1px ${accentColor}` }}
          onKeyPress={handleKeyPress}
          isDisabled={isDisabled}
        />
        <InputRightElement>
          <Button
            size="sm"
            colorScheme="blue"
            borderRadius="lg"
            onClick={onSend}
            isDisabled={!value.trim() || isDisabled}
            isLoading={isLoading}
          >
            <Icon as={FiSend} />
          </Button>
        </InputRightElement>
      </InputGroup>
    </Box>
  );
};

export default ChatInput;